import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const Ticket = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="89" viewBox="0 0 89 51" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M89.0029 40.3846C83.5568 40.3846 79.1427 44.7987 79.1427 50.2448H10.3587C10.3587 44.7987 5.94465 40.3846 0.498566 40.3846V10.1254C5.94465 10.1254 10.3587 5.71134 10.3587 0.265259H79.1437C79.1437 5.71134 83.5578 10.1254 89.0038 10.1254L89.0029 40.3846Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
